export default "__VITE_ASSET__lsFTxuuW__"